import { Injectable } from '@angular/core';

@Injectable()
export class PermitToWorkConstantsService {

  constructor() { }

  public static CompanyConst = {
    B44: 'B44',
    QAMP: 'QAMP',
    INC: 'INC'
  }

  public static PTWGetURL = {
    savePTWRequest: 'api/ptw/post/savePTWRequest',
    GetPTWRequests: 'api/ptw/get/getPTWRequests',
    GetPTWRequestByPermitId: '/api/ptw/get/getPTWRequestByPermitId',
    ExportToExcelPTWPermits: '/api/ptw/get/exportToExcelPTWPermits',
    GetActivities: 'api/ptw/get/getPTWActivities',
    saveApprovals: 'api/ptw/post/saveApprovals',
    saveGasTestRecords: 'api/ptw/post/saveGasTestRecords',
    saveAllTablesRecords: 'api/ptw/post/saveAllTablesRecords',
    getAllTablesRecords: 'api/ptw/get/getAllTablesRecords',
    getTRICTablesRecords: 'api/ptw/get/getTRICRecords',
    GetPermitDataForMap: 'api/ptw/get/getPermitDataForMap',
    getPTWStatus: 'api/ptw/get/getStatus'
  };

  public static RoutingURLConstant = {
    MyPTWDashboard: '/ptw/raise-permit'
  };

  public static PTWNavigation: any = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Apply Permit',
        routeURL: '/ptw/raise-permit/',
        isClickable: true
      },
      {
        routeName: 'Permit Overview',
        routeURL: '/ptw/permit-overview/',
        isClickable: true
      },
      {
        routeName: 'Map View',
        routeURL: '/ptw/map-view/',
        isClickable: true
      }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Apply Permit',
        routeURL: '/ptw/raise-permit/',
        isClickable: true
      },
      {
        routeName: 'Permit Overview',
        routeURL: '/ptw/permit-overview/',
        isClickable: true
      },
      {
        routeName: 'Map View',
        routeURL: '/ptw/map-view/',
        isClickable: true
      }
    ],
    ReportRoutes: []
  };
}

export enum PermitType {
  RedEdge = 1,
  BlueEdge,
  NoPermit
}
export enum ApprovalType {
  ResponsibleSupervisor = 1,
  ProductionSupervisor,
  Extension,
  Certificate,
  CancellationApplied,
  CancellationApproval
}
export enum AllTableRecordType {
  OtherAffectedCustodian = 1,
  SafetyCoordination,
  Validation,
  Acceptance,
  Suspension,
  TRICTalk
}
export enum PermitStatus {
  Cancel = 1,
  Completed,
  Active,
  Expired,
  PendingForAuthorization,
  AuthorizedByRS,
  PendingForExtension,
  ActiveExtensionAuthorizedByRS,
  AuthorizedByPS,
  RejectedByRS,
  RejectedByPS,
  ExtensionRejectedByRS,
  PendingForCancellation,
  CancellationRejectedByAA,
  Cancelled,
  Deleted,
  Draft
}
